var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbs, function (breadcrumb) {
    return _c('b-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("變更密碼")])], 2)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 變更密碼 ")])]), _c('b-card-body', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "姓名",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.staff.name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "name", $$v);
      },
      expression: "staff.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.staff.employee_code,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "employee_code", $$v);
      },
      expression: "staff.employee_code"
    }
  })], 1), !!this.$route.query.profile ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "目前密碼"
    }
  }, [_c('b-input-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_c('b-form-input', {
    attrs: {
      "type": _vm.showOldPassword ? 'text' : 'password',
      "state": _vm.v$.form.oldPassword.$error ? false : null,
      "disabled": _vm.disabled,
      "placeholder": "請填入目前密碼"
    },
    model: {
      value: _vm.form.oldPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "oldPassword", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.oldPassword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showOldPassword = !_vm.showOldPassword;
      }
    }
  }, [_c('i', {
    class: ['mx-auto', _vm.showOldPassword ? 'fa fa-eye' : 'fa fa-eye-slash']
  })])], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.oldPassword.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "自動產生密碼"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.generatorPassword,
      callback: function callback($$v) {
        _vm.generatorPassword = $$v;
      },
      expression: "generatorPassword"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 密碼 "), _c('i', {
          staticClass: "fa fa-question-circle ml-2 text-muted",
          staticStyle: {
            "font-size": "1rem"
          },
          attrs: {
            "id": "change-password-tip-tooltip"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "change-password-tip-tooltip",
            "triggers": "hover",
            "placement": "right"
          }
        }, [_vm._v(" 密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號 ")])];
      },
      proxy: true
    }])
  }, [_c('b-input-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_c('b-form-input', {
    attrs: {
      "type": _vm.showPassword ? 'text' : 'password',
      "state": _vm.v$.form.password.$error ? false : null,
      "disabled": _vm.disabled,
      "placeholder": "密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號"
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.password"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    }
  }, [_c('i', {
    class: ['mx-auto', _vm.showPassword ? 'fa fa-eye' : 'fa fa-eye-slash']
  })])], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.password.$error
    }
  }, [_vm.v$.form.password.required && _vm.v$.form.password.required.$invalid ? [_vm._v(" 此欄位為必填 ")] : _vm.v$.form.password.minLength && _vm.v$.form.password.minLength.$invalid ? [_vm._v(" 密碼最少要 8 位數 ")] : _vm.v$.form.password.passwordComplexity && _vm.v$.form.password.passwordComplexity.$invalid ? [_vm._v(" 密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號 ")] : _vm._e()], 2)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "確認密碼"
    }
  }, [_c('b-input-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_c('b-form-input', {
    attrs: {
      "type": _vm.showPasswordConfirm ? 'text' : 'password',
      "state": _vm.v$.form.passwordConfirmation.$error ? false : null,
      "disabled": _vm.disabled,
      "placeholder": "密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號"
    },
    model: {
      value: _vm.form.passwordConfirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "passwordConfirmation", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.passwordConfirmation"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    staticClass: "mx-auto",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showPasswordConfirm = !_vm.showPasswordConfirm;
      }
    }
  }, [_c('i', {
    class: ['mx-auto', _vm.showPasswordConfirm ? 'fa fa-eye' : 'fa fa-eye-slash']
  })])], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.passwordConfirmation.$error
    }
  }, [_vm._v(" 需與密碼相同 ")])], 1)], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("更新")])], 1)])])])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }